import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=29b1f55e&scoped=true&"
import script from "./RadioButtons.vue?vue&type=script&lang=ts&"
export * from "./RadioButtons.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&id=29b1f55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1f55e",
  null
  
)

export default component.exports